import React from 'react'
import { useSelector } from 'react-redux'
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import { useFormikContext } from 'formik'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './DistancesSection.style'

const DistancesSection = () => {
  const classes = useStyles()

  const { eventCircuitCategoryResults } = useSelector((state) => state.championships)

  const { values, errors, touched, handleBlur, setValues } = useFormikContext()

  const circuitOptions = eventCircuitCategoryResults.distances
    ?.filter((x) => x.events.some((e) => values.events.some((d) => d.id === e.eventId)))
    .sort((a, b) => a.name.toLowerCase().trim().localeCompare(b.name.trim().toLowerCase()))

  return (
    <SectionBlock title='Distancias'>
      <div className={classes.container}>
        {circuitOptions?.map((c) => (
          <FormControlLabel
            key={c.name}
            control={
              <Checkbox
                color='primary'
                name='excludedDistances'
                onBlur={handleBlur}
                className={classes.checkbox}
                checked={!values.excludedDistances[c.name]?.checked}
                onChange={(e) =>
                  setValues((values) => {
                    const bindCategories = e.target.checked
                      ? eventCircuitCategoryResults.categories.filter(
                          (cat) =>
                            values.excludedCategories[cat.name]?.checked &&
                            cat.distances.every((d) => values.excludedDistances[d.name]?.checked)
                        )
                      : []

                    return {
                      ...values,
                      excludedDistances: {
                        ...values.excludedDistances,
                        [c.name]: { name: c.name, checked: !e.target.checked }
                      },
                      excludedCategories: bindCategories.reduce(
                        (acc, curr) => ({
                          ...acc,
                          [curr.name]: { ...curr, checked: false }
                        }),
                        { ...values.excludedCategories }
                      )
                    }
                  })
                }
              />
            }
            label={
              <Typography variant='h6' color='primary' className={classes.checkMiniLabel}>
                {c.name}
              </Typography>
            }
          />
        ))}

        {errors.excludedDistances && (
          <Typography
            variant='caption'
            color={touched.excludedDistances ? 'error' : 'inherit'}
            className={classes.altErrorMessage}>
            {errors.excludedDistances}
          </Typography>
        )}
      </div>
    </SectionBlock>
  )
}

export default DistancesSection
